/* eslint-disable eslint-comments/disable-enable-pair */
import { Config } from './typings';
import { exportI18nData, initI18nData } from './i18n';

async function wrapperInitI18nData({
  ns,
  defaultLocale,
  projectName,
  namespace,
  locale,
  context,
  resolve,
  cdn,
  zone,
  fetchOptions,
  debug,
}: any) {
  const requestI18n = context.source.rawRequest.i18n;
  let count = 0;
  const waitList: any[] = [];
  let hasDataLoaded = false;

  await (requestI18n.language !== locale && requestI18n.changeLanguage(locale));

  function tryResolve() {
    count++;

    if (count < ns.length) {
      return;
    }

    if (hasDataLoaded || requestI18n.getDataByLanguage(locale)) {
      exportI18nData(context, requestI18n, waitList);
      resolve();
      return;
    }

    if (locale === defaultLocale || !defaultLocale) {
      resolve();
      return;
    }

    wrapperInitI18nData({
      ns,
      defaultLocale,
      projectName,
      namespace,
      locale: defaultLocale,
      context,
      resolve,
      cdn,
      zone,
      fetchOptions,
      debug,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  (ns || []).forEach((namespace: string) => {
    initI18nData({
      projectName,
      namespace,
      locale,
      cdn,
      zone,
      fetchOptions,
      debug,
    })
      .then(
        (i18nData: {
          data?: { [translate_key: string]: string };
          url?: string;
        }) => {
          // eslint-disable-next-line @typescript-eslint/no-shadow
          const requestI18n = context.source.rawRequest.i18n;

          if (i18nData) {
            hasDataLoaded = true;
            if (i18nData.url) {
              waitList.push([locale, namespace, i18nData]);
            } else {
              i18nData.data &&
                requestI18n.addResources(locale, namespace, i18nData.data);
            }
          }
        },
      )
      .catch((err: any) => {
        console.error(err);
        context.logger?.error(err);
      })
      .finally(() => {
        tryResolve();
      });
  });
}

// 由于 async 中无法根据环境变量来进行 Node/Browser 的 tree shake，改造成 Promise
function wrapperAppInitInNode(
  context: any, // ServerContext
  config: Config,
) {
  let promiseRt: any = Promise.resolve(null);

  // node
  if (!process.browser) {
    promiseRt = new Promise(resolve => {
      const { starlingProjects, i18nOptions, defaultLocale } = config;
      const requestLanguage = context.source.rawRequest.language;
      // detected language
      const locale = requestLanguage || i18nOptions?.fallbackLng || 'en';
      if (!requestLanguage) {
        const warnMsg = `App.init cannot find detected lnaguage: ${context.request.language}; downgrade to ${locale}`;
        console.warn(warnMsg);
        context?.logger?.warn(warnMsg);
      }

      (starlingProjects || []).forEach(({ projectName, namespace }) => {
        wrapperInitI18nData({
          ns: namespace,
          defaultLocale,
          projectName,
          locale,
          context,
          resolve,
          cdn: config.cdn,
          zone: config.zone,
          fetchOptions: config.fetchOptions,
          debug: config.debug,
        });
      });
    });
  }
  return promiseRt;
}

// wrap init
export function wrapperAppInit(
  AppWrapper: React.ComponentType,
  config: Config,
  initI18n: (i18n: any, req: any, res: any) => Promise<void>,
) {
  // original App.init
  const _init = (AppWrapper as any).init;

  (AppWrapper as any).init = async function(context: any) {
    // node
    if (!process.browser && context.targetRenderLevel !== 0) {
      await initI18n(
        context.source.rawRequest.i18n,
        context.source.rawRequest,
        context.source.rawRequest.res,
      );
      await wrapperAppInitInNode(context, config);
    }

    _init && (await _init(context));
  };
}
